import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { NAV_LINKS, IMAGES } from '../data/content'

function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [scrolled, setScrolled] = useState(false)
    const location = useLocation()

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20)
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const isActive = (href) => {
        if (href === '/') {
            return location.pathname === '/'
        }
        return location.pathname.startsWith(href)
    }

    return (
        <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-transparent'
            }`}>
            <div className="max-w-[1500px] mx-auto px-10 py-3 flex items-center justify-between">
                {/* Logo - Left */}
                <Link to="/" className="flex items-center">
                    <img
                        src={IMAGES.logo}
                        alt="CS Foreach Logo"
                        className="h-10 w-auto"
                    />
                </Link>

                {/* Desktop Navigation - Center */}
                <nav className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
                    {NAV_LINKS.filter(link => link.label !== 'GET INVOLVED').map((link) => (
                        <Link
                            key={link.label}
                            to={link.href}
                            className={`text-lg font-semibold tracking-wide transition-colors ${isActive(link.href)
                                ? 'text-brand-blue'
                                : 'text-gray-900 hover:text-brand-blue'
                                }`}
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                {/* GET INVOLVED - Right */}
                <div className="hidden md:block">
                    {NAV_LINKS.filter(link => link.label === 'GET INVOLVED').map((link) => (
                        <Link
                            key={link.label}
                            to={link.href}
                            className="px-5 py-2 bg-brand-blue text-white text-lg font-semibold tracking-wide rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            {link.label}
                        </Link>
                    ))}
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden flex flex-col gap-1.5 p-2"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                    aria-expanded={mobileMenuOpen}
                >
                    <span
                        className={`w-6 h-0.5 bg-gray-700 transition-transform ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''
                            }`}
                    />
                    <span
                        className={`w-6 h-0.5 bg-gray-700 transition-opacity ${mobileMenuOpen ? 'opacity-0' : ''
                            }`}
                    />
                    <span
                        className={`w-6 h-0.5 bg-gray-700 transition-transform ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
                            }`}
                    />
                </button>
            </div>

            {/* Mobile Navigation */}
            <nav
                className={`md:hidden overflow-hidden transition-all duration-300 ${mobileMenuOpen ? 'max-h-64' : 'max-h-0'
                    }`}
            >
                <div className="flex flex-col px-4 pb-4 bg-white border-t">
                    {NAV_LINKS.map((link) => (
                        <Link
                            key={link.label}
                            to={link.href}
                            className={`py-3 text-base font-medium border-b border-gray-100 ${isActive(link.href)
                                ? 'text-brand-blue'
                                : 'text-gray-700'
                                }`}
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            {link.label}
                        </Link>
                    ))}
                </div>
            </nav>
        </header>
    )
}

export default Header
